<p-button
  [text]="true"
  severity="contrast"
  styleClass="!h-7
    !px-1.5
    !py-1
    !gap-[0.25rem]
    !text-(--p-primary-500)
    hover:!bg-(--p-neutral-500)
    hover:!border-(--p-primary-100)"
  [pTooltip]="'@@floating-popup-histogram-manual-correlation' | translate"
  (click)="openCustomCorrelationPopup()"
  tooltipPosition="bottom"
  tooltipStyleClass="text-[0.75rem] !z-app-overlay-0">
  <svg-icon src="icons/icon-drop.svg" class="text-(--p-primary-500)" name="icon-drop"></svg-icon>

  @let isScreenMdUp = scrRes.isScreenMdUp();
  @let isLabelVisible = !isLabelHidden();

  @if (isScreenMdUp && isLabelVisible) {
    <span class="text-(--p-primary-500) text-[0.6875rem] font-medium leading-4 ml-1" translate="@@floating-popup-histogram-manual-correlation"></span>
  }
</p-button>